<template>
  <div
    id="mdd-pagina-cuaderno"
    class="container d-flex align-center"
    style="{ min-height: 100hv }"
  >
    <!-- full -->
    <v-row v-if="showNote">
      <v-container class="zoom">
        <!-- Voz de la Misericordia -->
        <v-row
          align="center"
          class="d-flex justify-space-between px-3 overline font-weight-bold"
        >
          <span :class="colorText">
            {{ t.cuaderno.vdlm }}
          </span>
          <span class="px-1">
            <v-btn
              :ripple="false"
              outlined
              x-small
              dark
              :class="colorName + ' lighten-2'"
            >
              {{ t.dias.hoy }}
            </v-btn>
          </span>
        </v-row>
        <v-row v-show="userNote.vdm">
          <v-col class="display-1 font-weight-thin font-italic">
            {{ userNote.vdm }}
          </v-col>
        </v-row>

        <!-- oracion personal -->
        <v-row class="pt-4">
          <v-col class="pb-0 overline font-weight-bold" :class="colorText">
            {{ t.cuaderno.tuOraPerson }}
          </v-col>
        </v-row>
        <v-row v-show="userNote.ora">
          <v-col>
            {{ userNote.ora }}
          </v-col>
        </v-row>

        <!-- compromiso personal -->
        <v-row class="pt-4">
          <v-col class="pb-0 overline font-weight-bold" :class="colorText">
            {{ t.cuaderno.tuCompromHoy }}
            <v-icon small>{{ iconoCompromisoTxt }}</v-icon>
          </v-col>
        </v-row>
        <v-row v-show="userNote.com">
          <v-col class="flex-grow-1 flex-shrink-0">
            {{ userNote.com }}
          </v-col>
          <v-col class="flex-grow-0 flex-shrink-1">
            <v-btn class="white" icon elevation="2" @click="toggleCompromiso">
              <v-icon>{{ iconoCompromiso }}</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-row>

    <!-- vacio o incompleto -->
    <v-row v-else>
      <v-container fluid>
        <v-row>
          <v-img
            aspect-ratio="0.754"
            contain
            src="/static/svg/cuaderno.svg"
            min-height="180px"
            max-height="225px"
          ></v-img>
        </v-row>
        <v-row class="body-1 mt-2 text-center">
          <v-col class="col-xs-12 col-sm-12 col-md-8 ma-auto">
            <p v-html="t.cuaderno.msgDiaIncompleto"></p>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-btn class="mt-2" rounded @click.stop="showHelp = !showHelp">
            <v-icon left>help_outline</v-icon>{{ t.cuaderno.aprendeComo }}
          </v-btn>
        </v-row>
      </v-container>
    </v-row>

    <!-- mensaje de ayuda -->
    <v-dialog v-model="showHelp" width="400" scrollable>
      <v-card>
        <v-card-title>{{ t.cuaderno.deOracion }}</v-card-title>
        <!-- texto -->
        <v-divider></v-divider>
        <v-card-text class="pa-4">
          <span class="overline font-weight-black" :class="colorText">
            {{ t.cuaderno.vdlm }}
          </span>
          <p class="body-1">
            <v-icon :color="colorName + ' darken-2'">favorite_border</v-icon>
            <span> {{ t.cuaderno.msgVoz }}</span>
          </p>
          <span class="overline font-weight-black" :class="colorText">
            {{ t.cuaderno.escribeOra }}
          </span>
          <p class="body-1">
            <v-icon :color="colorName + ' darken-2'">comment</v-icon>
            <span> {{ t.cuaderno.msgEscribeOra }}</span>
          </p>
          <span class="overline font-weight-black" :class="colorText">
            {{ t.cuaderno.hazComprom }}
          </span>
          <p class="body-1">
            <v-icon :color="colorName + ' darken-2'">how_to_reg</v-icon>
            <span> {{ t.cuaderno.msgHazComprom }}</span>
          </p>
        </v-card-text>
        <!-- botones -->
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="colorName" text @click="showHelp = false">
            {{ t.app.cerrar }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import mixAppConfig from "../../mixs/mixAppConfig.js";
import mixUserConfig from "../../mixs/mixUserConfig.js";
import mixUserColor from "../../mixs/mixUserColor.js";

import infoo from "../../plugins/infoo";

export default {
  name: "mdd-pagina-cuaderno-hoy",
  mixins: [mixAppConfig, mixUserConfig, mixUserColor],
  props: ["userNote"],
  data() {
    return {
      showHelp: false
    };
  },
  computed: {
    appSizes() {
      return this.$store.getters["app/sizes"];
    },
    helpFull() {
      return this.userAuth.created === this.userNote._uid;
    },
    hoy() {
      let today = infoo.hoy;
      return {
        anio: today.anio,
        mes: today.mes,
        dia: today.dia,
        iso: today.iso,
        nombreDia: this.t.dias[today.diaSem],
        nombreMes: this.t.meses[today.mes]
      };
    },
    iconoCompromiso() {
      let i = ["", "sentiment_very_dissatisfied", "done", "done_all"];
      let idx = this.userNote.cok;
      return this.userNote ? i[idx] : "";
    },
    iconoCompromisoTxt() {
      let i = ["", "close", "done", "done_all"];
      let idx = this.userNote.cok;
      return this.userNote ? i[idx] : "";
    },
    imgHeight() {
      return this.$vuetify.breakpoint.height - this.$vuetify.application.top;
    },
    showNote() {
      let n = this.userNote;
      return n.vdm !== "" || n.ora !== "" || n.com !== "";
    },
    uidLocal() {
      return "user/" + this.userAuth.uid + "/notes/" + this.userNote._uid;
    },
    userAuth() {
      return this.$store.getters["user/auth"];
    }
  },
  methods: {
    toggleCompromiso() {
      this.$store.commit("user/notes/compromisoOk", {
        docId: this.userNote._uid,
        uidLocal: this.uidLocal
      });
    }
  }
};
</script>
